
import httpClient from "../Core/http";

class ServiceCallsAPi {
  getCustomerServiceCalls(params: any, signal: any): Promise<any> {
    let url = "serviceCall/customer";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url, { params: params, signal: signal })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  }

  getMachineServiceCalls(params: any, signal: any): Promise<any> {
    let url = "serviceCall/machine";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url, { params: params, signal: signal })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  }
}

export const ServiceCallsApi = new ServiceCallsAPi();
